import { z } from 'zod';
import { AuditedFields, IsoDateTime, QueryBoolean, Uuid, Version } from './common.js';
/**
 * Salles et tables d'un point de vente (ADR-016, module `restaurant`).
 * L'état d'une table n'est jamais stocké : il se déduit de la commande ouverte.
 */
export const DiningArea = z
    .object({
    id: Uuid,
    outletId: Uuid,
    name: z.string(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
    version: Version,
})
    .merge(AuditedFields);
export const CreateDiningAreaRequest = z.object({
    name: z.string().trim().min(1).max(60),
    sortOrder: z.number().int().min(0).max(999).default(0),
});
export const UpdateDiningAreaRequest = z.object({
    name: z.string().trim().min(1).max(60).optional(),
    sortOrder: z.number().int().min(0).max(999).optional(),
    isActive: z.boolean().optional(),
    version: Version,
});
export const TableShape = z.enum(['SQUARE', 'ROUND', 'RECT']);
export const DiningTable = z
    .object({
    id: Uuid,
    outletId: Uuid,
    areaId: Uuid.nullable(),
    code: z.string(),
    seats: z.number().int(),
    shape: TableShape,
    /** Position sur le plan de salle (grille 0–100). */
    posX: z.number().int(),
    posY: z.number().int(),
    isActive: z.boolean(),
    version: Version,
})
    .merge(AuditedFields);
export const CreateDiningTableRequest = z.object({
    areaId: Uuid.nullable().optional(),
    code: z.string().trim().min(1).max(10),
    seats: z.number().int().min(1).max(50).default(4),
    shape: TableShape.default('SQUARE'),
    posX: z.number().int().min(0).max(100).default(0),
    posY: z.number().int().min(0).max(100).default(0),
});
export const UpdateDiningTableRequest = z.object({
    areaId: Uuid.nullable().optional(),
    code: z.string().trim().min(1).max(10).optional(),
    seats: z.number().int().min(1).max(50).optional(),
    shape: TableShape.optional(),
    posX: z.number().int().min(0).max(100).optional(),
    posY: z.number().int().min(0).max(100).optional(),
    isActive: z.boolean().optional(),
    version: Version,
});
export const ListDiningQuery = z.object({ includeInactive: QueryBoolean.optional() });
/** État dérivé d'une table (plan de salle, tokens `--tb-*` de la charte). */
export const TableStatus = z.enum(['FREE', 'OCCUPIED', 'BILL_REQUESTED']);
/** Résumé de la commande ouverte sur une table (plan de salle). */
export const OpenOrderSummary = z.object({
    id: Uuid,
    reference: z.string(),
    dailyNumber: z.number().int(),
    covers: z.number().int().nullable(),
    total: z.number(),
    itemsCount: z.number().int(),
    preparationStatus: z.enum(['NEW', 'IN_PREPARATION', 'READY', 'SERVED']),
    openedAt: IsoDateTime,
    serverName: z.string().nullable(),
});
export const FloorTable = DiningTable.extend({
    status: TableStatus,
    openOrder: OpenOrderSummary.nullable(),
});
export const FloorPlan = z.object({
    outletId: Uuid,
    areas: z.array(DiningArea),
    tables: z.array(FloorTable),
});
//# sourceMappingURL=restaurant.js.map